<div class="ir-item-line th-filter" *ngIf="points?.length">
  <div class="ir-item-cell s4 clickable" (click)="setOrderBy('name')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'common.name' | translate }}
    </span>
  </div>
  <div (click)="setOrderBy('etag')" class="ir-item-cell s4 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ 'points.last-modified-date' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s2 clickable right" (click)="setOrderBy('status')">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>

      {{ 'common.status' | translate }}
    </span>
  </div>
</div>
<div class="ir-item-empty ir-mv8" *ngIf="allItems?.length == 0">
  <p>
    <span>{{ 'points.no-points' | translate }}</span>
  </p>
</div>
<div class="ir-content-flow" *ngIf="allItems?.length > 0" [ngClass]="allItems?.length > 0 ? 'has-filter has-actions' : ''">
  <div
    *ngFor="let item of allItems | orderBy : orderByFieldName : direction | searchBy : query"
    class="ir-item-line th-point clickable indent"
    [ngClass]="item.status === 100 ? 'done' : ''"
    (click)="item.type === 100 ? openFolder(item) : openPoint(item)"
  >
    <!-- if folder -->
    <div class="ir-item-cell s4" *ngIf="item.type === 100">
      <div class="ir-item-selector" (click)="selectFolder($event, item)">
        <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
        <i class="material-icons" *ngIf="item.selected">check_box</i>
      </div>
      <span class="icon-label"> <i class="material-icons">folder</i>{{ allItemsOrdersById[item.id] }} {{ item.name }}</span>
    </div>
    <div class="ir-item-cell s4" *ngIf="item.type === 100">
      <span></span>
    </div>
    <div *ngIf="item.type === 100" class="ir-item-cell s2 right strong statut">
      <ng-container *ngFor="let session of item.sessions">
        <i
          *ngIf="session.user"
          class="material-icons"
          [title]="session.user"
          [style.color]="session.color"
          [class.disabled]="session.away"
          [class.away]="session.away"
          [class.active]="!session.away"
          >account_circle</i
        >
      </ng-container>
      <i *ngFor="let icon of item.icons | orderBy : 'order'" class="material-icons {{ icon.classes }}">{{
        icon.count !== 0 ? icon.name : ''
      }}</i>
      <span>{{ item?.getProgression() }} %</span>
    </div>
    <!-- if point -->
    <div class="ir-item-cell s4" *ngIf="item.type === 200">
      <div class="ir-item-selector" (click)="selectPoint($event, item)">
        <i class="material-icons" *ngIf="!item.selected">check_box_outline_blank</i>
        <i class="material-icons" *ngIf="item.selected">check_box</i>
      </div>
      <span>{{ allItemsOrdersById[item.id] }} {{ item.name }}</span>
    </div>
    <div class="ir-item-cell s4" *ngIf="item.type === 200">
      <span>{{ item?.etag | formatDate }}</span>
    </div>
    <div *ngIf="item.type === 200" class="ir-item-cell s2 right strong statut">
      <ng-container *ngFor="let session of item.sessions">
        <i
          *ngIf="session.user"
          class="material-icons"
          [title]="session.user"
          [style.color]="session.color"
          [class.disabled]="session.away"
          [class.away]="session.away"
          [class.active]="!session.away"
          >account_circle</i
        >
      </ng-container>
      <i *ngFor="let icon of item.icons | orderBy : 'order'" class="material-icons {{ icon.classes }}">{{ icon.name }}</i>
      <i class="material-icons" *ngIf="item.isDraft()">remove</i>
      <i class="material-icons" *ngIf="item.isDone()">check</i>
      <i class="material-icons" *ngIf="item.isNotApplicable()">not_interested</i>
    </div>
  </div>
</div>
